// UI reducer types
export const uiConstant = {
  LOADING_TRUE: "LOADING_TRUE",
  LOADING_FALSE: "LOADING_FALSE",

  LAZY_LOADING_TRUE: "LAZY_LOADING_TRUE",
  LAZY_LOADING_FALSE: "LAZY_LOADING_FALSE",
};
